/* 煮鱼的内容数据：屏幕、页面区块、彩蛋共用 */
export const profile = {
    nickname: '熊煮鱼',
    nicknameEn: 'XIONG ZHUYU',
    douyinId: 'xiongzhuyu200761',
    douyinUrl: 'https://www.douyin.com/user/MS4wLjABAAAA7awIekJ5Rgil_f0_9v6qOoao5cELgMZVRP5sfl-4qto',
    tagline: 'Be creative, keep up.',
    introLines: [
        '19 岁，成都人，拍片子的。',
        '习惯把日子过成素材：教室窗边的夕阳、班赛最后一秒的绝杀、大连吹过来的海风——值得记住的瞬间，都该认真剪进时间线。',
        '镜头是我的第二双眼睛：拍兄弟、拍球场、拍路上的光。比起画质和参数，更在意有没有接住那个"就是现在"的瞬间。',
        '追影视飓风的更新学运镜，也在球场边为成都蓉城喊"雄起"；热爱的事有点多，好在每一件都能变成下一条视频。',
        '至于下一站——素材已经在路上了。'
    ],
    photoCaption: '大连 · 星海跨海大桥',
    stats: [
        { num: 28, display: '28', label: '作品' },
        { num: 19000, display: '1.9w', label: '获赞' },
        { num: 547, display: '547+', label: '粉丝' },
        { num: null, display: '∞', label: '热爱' }
    ],
    tags: [
        '🎬 剪辑与转场', '🌀 影视飓风粉', '🚁 大疆机长', '📷 影石 Ace Pro 2',
        '🖨️ 3D 打印', '💾 NAS 玩家', '🔴 成都蓉城', '🏀 篮球', '🎯 打瓦', '✈️ 在路上'
    ]
}

export const chapters = [
    { id: 'campus', no: '01', title: '成外岁月', sub: 'CFLS · 2023—2026' },
    { id: 'journey', no: '02', title: '在路上', sub: 'ON THE ROAD · 首屏那张照片，就拍在这座桥上' },
    { id: 'next', no: '03', title: '下一站…', sub: 'TO BE CONTINUED' }
]

export const works = [
    { id: '7604209820136246538', title: '哦？天崩开局？逆风翻盘？兄弟燃起来了啊', likes: 3196, chapter: 'campus', tag: '篮球 · 班赛决赛' },
    { id: '7606333843587818917', title: '一学期就这么过去了', likes: 1951, chapter: 'campus', tag: '卡点 · 回忆', pinned: true },
    { id: '7622249825727880677', title: '下一站，高考！！！！', likes: 625, chapter: 'campus', tag: '成人礼 · 兄弟' },
    { id: '7632274011128433929', title: '哦？数学老师在成外教职工联赛中上演压哨绝杀？', likes: 538, chapter: 'campus', tag: '篮球 · 大疆' },
    { id: '7650458135571828020', title: '同学，我们没有下学期了', likes: 239, chapter: 'campus', tag: '毕业典礼 · 镜头签', pinned: true },
    { id: '7562819923630624058', title: 'If we never wake up~', likes: 221, chapter: 'campus', tag: '卡点 · 大疆' },
    { id: '7587597801530445114', title: '举起你的双手 放纵你的脉搏', likes: 165, chapter: 'campus', tag: '校园 · 回忆' },
    { id: '7650056224415203429', title: '青春是一本太仓促的书', likes: 155, chapter: 'campus', tag: '夕阳 · 影石' },
    { id: '7570331701965125297', title: '成都的天气 🙌', likes: 128, chapter: 'campus', tag: '日常 · 卡点' },
    { id: '7575553776770178041', title: '同学打瓦吗', likes: 93, chapter: 'campus', tag: '无畏契约' },
    { id: '7652657513976695461', title: '嗯？怎么熄灯了？', likes: 269, chapter: 'journey', tag: '大连 · 星海跨海大桥' }
]

/* 影视飓风频道：B 站真实高播放视频，封面已离线像素粗糙化（assets/zhuyu/ms/） */
export const mediastorm = [
    { img: '/assets/zhuyu/ms/ms1.jpg', title: '我们买了一颗国产卫星。', play: '1432万' },
    { img: '/assets/zhuyu/ms/ms2.jpg', title: '真开上机甲了？1600万粉丝Q&A！', play: '481万' },
    { img: '/assets/zhuyu/ms/ms3.jpg', title: '新地图解锁！影视飓风的电竞房？', play: '434万' },
    { img: '/assets/zhuyu/ms/ms4.jpg', title: '见了苹果CEO库克！问了他16个问题。', play: '199万' }
]

/* 屏幕轮播用（保持兼容：ZhuyuScreen 的 works 模式取前 8 条） */

export const egg = {
    month: 7, day: 14,
    title: '生日快乐，煮鱼！',
    message: [
        '19 岁这一年，你把毕业拍成了电影，把兄弟拍成了主角，把成都的天气都剪出了节奏。',
        '接下来的故事换了片场，但导演还是你。',
        '镜头别停——下一站，会比你剪出来的还好看。',
        '生日快乐。'
    ],
    photos: ['/assets/zhuyu/photo1.jpg']
}
